import { AG_GRID_LOCALE_VN } from "@ag-grid-community/locale";

export const AG_GRID_PAGE_SIZE_OPTIONS: number[] = [100, 500, 1000];

export const AG_GRID_LOCALE_DEFAULT = AG_GRID_LOCALE_VN;
